// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1HpNY","header":"ReportDetails_header__12Yjd","title":"ReportDetails_title__20o6w","left":"ReportDetails_left__4JAz-"};